import { CustomEvents } from './CustomEvents';
import { emit } from './EventsBus';

let mqObj = {};

const resHandler = obj => {
  for (let [key, value] of Object.entries(obj)) {
    let mqList = window.matchMedia(`(max-width: ${value})`);
    mqList.addListener(e => {
      if (e.matches) {
        emit(CustomEvents.MQ_EVENTS[key].out);
        console.debug(`out from ${key} breakpoint`);
      } else {
        emit(CustomEvents.MQ_EVENTS[key].in);
        console.debug(`in to ${key} breakpoint`);
      }
    });
  }
};

const getMqFromCss = selClass => {
  return new Promise((resolve, reject) => {
    let mediaTag = document.querySelector(`.${selClass}`),
      compStyles,
      mqStringFromCss;

    if (!mediaTag) {
      let head = document.querySelector('head');
      mediaTag = document.createElement('meta');
      mediaTag.classList.add(selClass);
      head.appendChild(mediaTag);
    }

    compStyles = window.getComputedStyle(mediaTag);
    mqStringFromCss = compStyles.getPropertyValue('font-family').replace(/"/g, "");

    return parseStyleToObject(mqStringFromCss).then(data => {
      resolve(data);
    });
  });
};

const parseStyleToObject = str => {
  return new Promise((resolve, reject) => {
    let styleObject = {};

    if (typeof str !== 'string') {
      return styleObject;
    }

    if (!str) {
      return styleObject;
    }

    styleObject = str.split('&').reduce(function(ret, param) {
      let parts = param.replace(/\+/g, ' ').split('=');
      let key = parts[0];
      let val = parts[1];
      key = decodeURIComponent(key);

      // missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      val = typeof val === 'undefined' ? null : decodeURIComponent(val);

      if (!ret.hasOwnProperty(key)) {
        ret[key] = val;
      } else if (Array.isArray(ret[key])) {
        ret[key].push(val);
      } else {
        ret[key] = [ret[key], val];
      }
      return ret;
    }, {});

    resolve(styleObject);
    // return styleObject;
  });
};

export const ResolutionHandler = () => {
  getMqFromCss('custom-mq').then(data => {
    resHandler(data);
    mqObj = data;
  });
};

/**
 *
 * @param {string} max - The name of the max-width breackpoint
 * @param {string} min - The name of the min-width breackpoint
 * @return {boolean}
 */
export const Matchmq = (max, min) => {
  if (!max && !min) return false;

  let maxString = '';
  let minString = '';

  if (max) {
    maxString = `(max-width: ${parseFloat(mqObj[max]) - 1}px)${min ? ' and ' : ''}`;
  }

  if (min) {
    minString = `(min-width: ${mqObj[min]})`;
  }

  return window.matchMedia(`${maxString}${minString}`).matches;
};
